<template>
    <div class="flex flex-col">
        <div class="bg-gray-200 w-full h-48 sm:h-72">
            <img
                v-if="showImage"
                :src="course.main_image.url"
                :alt="course.title"
                class="w-full h-full object-cover"
                @error.native="onImgError"/>
        </div>
        <div class="flex flex-col flex-1 bg-teal-dark py-6 px-6 text-white sm:px-10">
            <h3 class="text-lg sm:text-2xl font-bold">{{ course.title }}</h3>
            <p class="sm:text-lg mt-4 leading-normal mb-auto">{{ course.summary }}</p>
            <div class="mt-8">
                <AppLink :to="{name: 'course', params: {courseId: course.id}}" theme="primary-button">
                    Read more
                </AppLink>
            </div>
        </div>
    </div>
</template>

<script>

import AppLink from "@/Components/AppLink";

export default {

    name: "CourseCard",

    props: {
        course: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            hasImageError: false
        }
    },

    components: {
        AppLink
    },

    methods: {
        onImgError() {
            this.hasImageError = true
        }
    },

    computed: {
        showImage() {
            return this.course.main_image && this.course.main_image.url && !this.hasImageError;
        }
    }
};

</script>
